import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {DIAGRAM_VERSION_STATES_ENUM} from '../models/diagram-version.constant';

@Pipe({
  name: 'diagramState',
  standalone: true
})
export class DiagramStatePipe implements PipeTransform {
  private draft = this.translateSvc.instant('SEARCH.DIAGRAM_STATE_DRAFT');
  private master = this.translateSvc.instant('SEARCH.DIAGRAM_STATE_MASTER');
  private neverPublished = this.translateSvc.instant('SEARCH.DIAGRAM_STATE_NEVER_PUBLISHED');
  private archive = this.translateSvc.instant('SEARCH.DIAGRAM_STATE_ARCHIVE');
  private ready = this.translateSvc.instant('SEARCH.DIAGRAM_STATE_READY');
  private beingAuthorised = this.translateSvc.instant('SEARCH.DIAGRAM_STATE_BEING_AUTHORISED');
  constructor(private translateSvc: TranslateService) {}
  transform(diagramState: string): string {
    if (diagramState.startsWith('r_')) {
      diagramState = DIAGRAM_VERSION_STATES_ENUM.ARCHIVE;
    }

    switch (diagramState) {
      case DIAGRAM_VERSION_STATES_ENUM.DRAFT:
        return this.draft;

      case DIAGRAM_VERSION_STATES_ENUM.BEING_AUTHORISED:
        return this.beingAuthorised;

      case DIAGRAM_VERSION_STATES_ENUM.MASTER:
        return this.master;

      case DIAGRAM_VERSION_STATES_ENUM.NEVER_PUBLISHED:
        return this.neverPublished;

      case DIAGRAM_VERSION_STATES_ENUM.ARCHIVE:
        return this.archive;

      case DIAGRAM_VERSION_STATES_ENUM.READY:
        return this.ready;

      default:
        return '';
    }
  }
}
